/**
 * @description Promise based setTimeout
 * @param {number} duration
 * @return {Promise<any>}
 */
export const delay = ( duration: number = undefined ): Promise<any> => {
	return new Promise(
		( resolve: ( value: any ) => void ) => {
			setTimeout(
				() => resolve( true ), duration
			);
		}
	);
};